export const MOOD_DATA = {
  calm: {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <path d="M8 15s1.5-1 4-1 4 1 4 1"/>
        <line x1="9" y1="9" x2="9.01" y2="9"/>
        <line x1="15" y1="9" x2="15.01" y2="9"/>
      </svg>
    ),
    label: 'Calm',
    color: '#3B82F6'
  },
  happy: {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <path d="M8 14s1.5 2 4 2 4-2 4-2"/>
        <line x1="9" y1="9" x2="9.01" y2="9"/>
        <line x1="15" y1="9" x2="15.01" y2="9"/>
      </svg>
    ),
    label: 'Happy',
    color: '#10B981'
  },
  neutral: {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <line x1="8" y1="15" x2="16" y2="15"/>
        <line x1="9" y1="9" x2="9.01" y2="9"/>
        <line x1="15" y1="9" x2="15.01" y2="9"/>
      </svg>
    ),
    label: 'Neutral',
    color: '#6B7280'
  },
  anxious: {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <path d="M8 15s1 -1 4 -1 4 1 4 1"/>
        <path d="M9 10c0-1 .5-1.5 1-1.5s1 .5 1 1.5"/>
        <path d="M15 10c0-1-.5-1.5-1-1.5s-1 .5-1 1.5"/>
      </svg>
    ),
    label: 'Anxious',
    color: '#F59E0B'
  },
  sad: {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <path d="M8 17s1.5-2 4-2 4 2 4 2"/>
        <line x1="9" y1="9" x2="9.01" y2="9"/>
        <line x1="15" y1="9" x2="15.01" y2="9"/>
      </svg>
    ),
    label: 'Sad',
    color: '#8B5CF6'
  },
  overwhelmed: {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <circle cx="9" cy="10" r="1.5"/>
        <circle cx="15" cy="10" r="1.5"/>
        <path d="M9 16a3 3 0 0 0 6 0"/>
      </svg>
    ),
    label: 'Overwhelmed',
    color: '#EF4444'
  }
};

export const MOOD_OPTIONS = [
  {
    value: 'all',
    label: 'All Moods',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <path d="M8 14s1.5 2 4 2 4-2 4-2"/>
        <line x1="9" y1="9" x2="9.01" y2="9"/>
        <line x1="15" y1="9" x2="15.01" y2="9"/>
      </svg>
    )
  },
  {
    value: 'calm',
    label: 'Calm',
    icon: MOOD_DATA.calm.icon
  },
  {
    value: 'happy',
    label: 'Happy',
    icon: MOOD_DATA.happy.icon
  },
  {
    value: 'neutral',
    label: 'Neutral',
    icon: MOOD_DATA.neutral.icon
  },
  {
    value: 'anxious',
    label: 'Anxious',
    icon: MOOD_DATA.anxious.icon
  },
  {
    value: 'sad',
    label: 'Sad',
    icon: MOOD_DATA.sad.icon
  },
  {
    value: 'overwhelmed',
    label: 'Overwhelmed',
    icon: MOOD_DATA.overwhelmed.icon
  }
];

export const getMoodData = (mood) => {
  return MOOD_DATA[mood] || MOOD_DATA.neutral;
};
